<template>
  <v-dialog v-model="dialog" max-width="420" scrollable>
    <template #activator="{ on }">
      <slot name="activator" :on="on">
        <v-btn icon v-on="on" :title="'QR de ' + (miembro.nombre || 'miembro')">
          <v-icon>mdi-qrcode</v-icon>
        </v-btn>
      </slot>
    </template>

    <v-card rounded="xl" class="overflow-hidden">
      <!-- Header con estado -->
      <v-card-title class="pa-0">
        <div
          class="w-100 pa-4 d-flex align-center"
          :style="{ background: estadoColor }"
        >
          <v-avatar size="52" class="mr-3 elevation-3">
            <v-img :src="miembro.imagen || ''" />
          </v-avatar>
          <div>
            <div class="white--text font-weight-bold text-subtitle-1 text-truncate" style="max-width:220px">
              {{ miembro.nombre }}
            </div>
            <div class="white--text text-caption opacity-80">
              Matrícula: <strong>{{ miembro.matricula }}</strong>
            </div>
          </div>
          <v-spacer />
          <v-chip dark small :color="estadoBadge">
            <v-icon left x-small>mdi-circle</v-icon>
            {{ miembro.estado || 'ACTIVO' }}
          </v-chip>
        </div>
      </v-card-title>

      <v-card-text class="text-center py-6">
        <!-- QR Canvas -->
        <div class="qr-wrapper d-inline-block pa-3 rounded-xl elevation-4" style="background:#fff">
          <canvas ref="qrCanvas" />
        </div>

        <!-- Info membresía -->
        <div class="mt-4">
          <v-chip small color="primary" dark class="mr-1">
            <v-icon left x-small>mdi-dumbbell</v-icon>
            {{ miembro.membresia || 'Sin membresía' }}
          </v-chip>
          <v-chip small :color="diasColor" dark>
            <v-icon left x-small>mdi-calendar-clock</v-icon>
            {{ diasTexto }}
          </v-chip>
        </div>

        <p class="text-caption text--secondary mt-3">
          Muestra este QR en recepción para registrar tu visita
        </p>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-3 justify-center">
        <v-btn color="primary" rounded outlined small @click="imprimir">
          <v-icon left small>mdi-printer</v-icon> Imprimir tarjeta
        </v-btn>
        <v-btn color="grey" rounded outlined small @click="dialog = false">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Área de impresión oculta -->
    <div id="tarjeta-impresion" style="display:none">
      <div class="tarjeta-print">
        <div class="tarjeta-header">
          <strong>{{ gimnasioNombre }}</strong>
        </div>
        <div class="tarjeta-body">
          <canvas id="qr-print" />
          <div class="tarjeta-nombre">{{ miembro.nombre }}</div>
          <div class="tarjeta-matricula">{{ miembro.matricula }}</div>
          <div class="tarjeta-membresia">{{ miembro.membresia }}</div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRMiembro',
  props: {
    miembro: { type: Object, required: true },
  },

  data() {
    return {
      dialog: false,
      gimnasioNombre: localStorage.getItem('nombreGimnasio') || 'GymPro',
    }
  },

  computed: {
    estadoColor() {
      switch (this.miembro.estado) {
        case 'ACTIVO':  return 'linear-gradient(135deg, #1de9b6, #1565c0)'
        case 'VENCIDO': return 'linear-gradient(135deg, #ff5252, #b71c1c)'
        default:        return 'linear-gradient(135deg, #78909c, #37474f)'
      }
    },
    estadoBadge() {
      return this.miembro.estado === 'ACTIVO' ? 'success' : 'error'
    },
    diasRestantes() {
      if (!this.miembro.fechaFin) return null
      const fin  = new Date(this.miembro.fechaFin)
      const hoy  = new Date()
      hoy.setHours(0,0,0,0)
      return Math.ceil((fin - hoy) / (1000 * 60 * 60 * 24))
    },
    diasTexto() {
      if (this.diasRestantes === null) return 'Sin fecha'
      if (this.diasRestantes <= 0)    return 'Vencida'
      if (this.diasRestantes === 1)   return '1 día restante'
      return this.diasRestantes + ' días restantes'
    },
    diasColor() {
      const d = this.diasRestantes
      if (d === null || d <= 0)  return 'error'
      if (d <= 5)                return 'orange darken-1'
      return 'teal darken-1'
    },
  },

  watch: {
    dialog(val) {
      if (val) this.$nextTick(() => this.generarQR())
    },
  },

  methods: {
    generarQR() {
      var canvas = this.$refs.qrCanvas
      if (!canvas || !this.miembro.matricula) return
      QRCode.toCanvas(canvas, this.miembro.matricula, {
        width: 220,
        margin: 2,
        color: {
          dark:  '#1a237e',
          light: '#ffffff',
        },
        errorCorrectionLevel: 'H',
      }, function(err) {
        if (err) console.error('QR error:', err)
      })
    },

    imprimir() {
      var win = window.open('', '_blank', 'width=400,height=500')
      var m   = this.miembro
      var nombre = this.gimnasioNombre

      // Generar QR como dataURL para la ventana de impresión
      QRCode.toDataURL(m.matricula, {
        width: 200, margin: 2,
        errorCorrectionLevel: 'H',
        color: { dark: '#1a237e', light: '#ffffff' },
      }, function(err, url) {
        var html = '<!DOCTYPE html><html><head><title>Tarjeta QR</title>' +
          '<style>' +
          'body{margin:0;font-family:Arial,sans-serif;display:flex;justify-content:center;align-items:center;min-height:100vh;background:#f5f5f5}' +
          '.card{width:280px;border-radius:16px;overflow:hidden;box-shadow:0 8px 24px rgba(0,0,0,.15);background:#fff}' +
          '.card-header{background:linear-gradient(135deg,#1de9b6,#1565c0);color:#fff;padding:14px 16px;font-weight:bold;font-size:15px;text-align:center}' +
          '.card-body{padding:20px;text-align:center}' +
          '.card-body img{border-radius:8px;border:3px solid #1565c0}' +
          '.name{font-size:16px;font-weight:bold;color:#1a237e;margin:10px 0 2px}' +
          '.matricula{font-size:12px;color:#607d8b;margin-bottom:4px}' +
          '.plan{font-size:11px;background:#e8eaf6;color:#3949ab;border-radius:20px;padding:3px 10px;display:inline-block}' +
          '@media print{body{background:#fff}}' +
          '</style></head><body>' +
          '<div class="card">' +
          '<div class="card-header">🏋️ ' + nombre + '</div>' +
          '<div class="card-body">' +
          '<img src="' + url + '" width="200" height="200" />' +
          '<div class="name">' + m.nombre + '</div>' +
          '<div class="matricula">Matrícula: ' + m.matricula + '</div>' +
          '<div class="plan">' + (m.membresia || 'Miembro') + '</div>' +
          '</div></div>' +
          '<script>window.onload=function(){setTimeout(function(){window.print();window.close()},400)}<\/script>' +
          '</body></html>'
        win.document.write(html)
        win.document.close()
      })
    },
  },
}
</script>

<style scoped>
.qr-wrapper {
  border: 3px solid #e8eaf6;
}
</style>



// WEBPACK FOOTER //
// src/components/Miembros/QRMiembro.vue